import LargeCreditCardOfferExp from './LargeCreditCardOfferExp';
import StandardRedesignCreditCardOfferTwoView from './StandardRedesignCreditCardOfferTwoView';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';

const MobileCreditCardOfferView = props => {
  const { isLargeCreditCardTemplate } = props;
  if (isLargeCreditCardTemplate) {
    return <LargeCreditCardOfferExp {...props} />;
  }
  return <StandardRedesignCreditCardOfferTwoView {...props} />;
};

const StandardRedesignCreditCardOfferTwo = props => {
  return (
    <>
      <FlexContainer column className="m-hide">
        <StandardRedesignCreditCardOfferTwoView {...props} />
      </FlexContainer>
      <FlexContainer column className="d-hide">
        <MobileCreditCardOfferView {...props} />
      </FlexContainer>
    </>
  );
};

export default StandardRedesignCreditCardOfferTwo;
